import { Box, LinearProgress } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { sumStatement } from '../../../services/excel/statementSums'
import FigureCards from '../../UI/FigureCards'

StatementFileSum.propTypes = {
  agreement: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
}

export default function StatementFileSum({ agreement, file }) {
  const [items, setItems] = useState([
    { subtitle: "Chiffre d'affaires et volume", figure: <LinearProgress /> },
    { subtitle: "Remise en fin d'année", figure: <LinearProgress /> },
    { subtitle: 'Détail par colonne', figure: <LinearProgress /> },
  ])

  useEffect(() => {
    sumStatement(file, agreement).then((res) => {
      setItems((prevItems) => {
        const baseItems = prevItems.slice(0, 2)
        const newItems = [
          { ...baseItems[0], figure: res.turnover },
          { ...baseItems[1], figure: res.totalDiscount },
        ]
        if (res.columnDiscounts) {
          res.columnDiscounts.forEach((col) => {
            newItems.push({ subtitle: `RFD ${col.name}`, figure: col.value })
          })
        }
        return newItems
      })
    })
  }, [])

  return (
    <Box mt={4}>
      <FigureCards title="Totaux" items={items} />
    </Box>
  )
}
